// Help text for: Header, branch selector and other chrome shared by every tab.
// Keys are referenced as "common.<field>" by <FieldHelp id=... />. Entry shape:
//   title  - field name as shown on screen
//   use    - what the field is for / how to read it
//   source - measured | calculated | backend | default | setting | input
//   how    - where the value comes from: formula, default value, or who sets it
const help = {
  branchSelector: {
    title: "Branches",
    use: "Narrows every screen down to one branch of your site. \"All Branches\" shows everything your login can see.",
    source: "input",
    how: "Comes pre-filled as All Branches, and goes back to All whenever the app reloads. The list holds the nodes marked as branches during EnViz setup; a machine belongs to the nearest branch above it. It only appears if your site has branches.",
  },
  unreadAlerts: {
    title: "Unread alerts",
    use: "How many open alerts you have not read yet. Click the bell to see them.",
    source: "backend",
    how: "Counts the open, unread alerts for the machines your login can see, taken from the 100 newest open ones; 9+ means more than nine. Refreshed every 60 seconds, and again each time you close the alert panel.",
  },
  clientName: {
    title: "Account",
    use: "The company account you are signed in to.",
    source: "backend",
    how: "The company name saved on your account, shown from your sign-in details; if no name is saved it falls back to your username. The logo is the one uploaded to your account, when there is one.",
  },
  superAdminMode: {
    title: "Super Admin",
    use: "You are signed in as an Enfo super admin, not as an ordinary client user.",
    source: "backend",
    how: "Shown for as long as a super admin session is open. Anything you change applies to the client account you are looking at right now.",
  },
  viewingClient: {
    title: "Viewing client",
    use: "The client account whose dashboard you are looking at. Click it to move to a different client.",
    source: "input",
    how: "Shows that client's company name, or their username if no name is saved. Picking a client signs this session in to that account and reloads the page.",
  },
  subUserTag: {
    title: "sub-user",
    use: "This login was created under a client account. It is not the account's own main login.",
    source: "setting",
    how: "Sub-users are set up with Multi Tier > Add Credentials and see only the part of the site given to them — their primary node, minus any machines left out.",
  },
  premiumTag: {
    title: "premium",
    use: "This client is on the premium tier.",
    source: "setting",
    how: "The tier Enfo chose when the account was set up, which starts as standard. Only Enfo can change it later.",
  },
  blockedTag: {
    title: "blocked",
    use: "Dashboard access is switched off for this client, so their own users cannot open it. You can still look at it as super admin.",
    source: "backend",
    how: "Shown when Enfo has switched off either the client's billing status or their dashboard status.",
  },
  viewingTag: {
    title: "viewing",
    use: "The client you are looking at right now.",
    source: "calculated",
    how: "Matches the account this session is signed in to.",
  },
  clientCount: {
    title: "Clients",
    use: "How many client logins you can move between.",
    source: "calculated",
    how: "Counts every client login in EnViz, sub-users included, in the order they were created. Enfo's own super admin logins are not counted.",
  },
};

export default help;
